module.exports = __webpack_public_path__ + "img/测试图片.1c2b5fde.webp";